/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from "react";
import MDTypography from "components/MDTypography";
import { apiGetNotisSummary, apiGetTunggakanByBahagian } from "api/dashboard";
import { useMaterialUIController } from "context";

export default function data() {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const isKEWUser = user?.id_pengguna?.toLowerCase() === "huda";
  
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBahagian, setSelectedBahagian] = useState("UEU");

  const fetchTunggakanData = async (bahagian) => {
    try {
      setLoading(true);
      const data = await apiGetTunggakanByBahagian(bahagian);
      const fmt = (n) =>
        Number(n || 0).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      setRows([
        {
          bahagian: (
            <MDTypography variant="caption" color="text" fontWeight="medium" ml={2}>
              {data.bahagian}
            </MDTypography>
          ),
          bilangan: (
            <MDTypography variant="caption" color="text" fontWeight="medium">
              {data.bil_inbois}
            </MDTypography>
          ),
          jumlah: (
            <MDTypography variant="caption" color="text" fontWeight="medium" mr={2}>
              RM {fmt(data.jumlah)}
            </MDTypography>
          ),
        },
      ]);
    } catch (e) {
      setRows([{ bahagian, bilangan: 0, jumlah: "RM 0.00" }]);
    } finally {
      setLoading(false);
    }
  };

  const fetchNotisData = async () => {
    try {
      setLoading(true);
      const summary = await apiGetNotisSummary();
      const fmt = (n) =>
        Number(n || 0).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      setRows([
        {
          jenis: (
            <MDTypography variant="caption" color="text" fontWeight="medium" ml={2}>
              PERTAMA
            </MDTypography>
          ),
          bilangan: (
            <MDTypography variant="caption" color="text" fontWeight="medium">
              {summary.notisPertama.count}
            </MDTypography>
          ),
          jumlah: (
            <MDTypography variant="caption" color="text" fontWeight="medium" mr={2}>
              RM {fmt(summary.notisPertama.total)}
            </MDTypography>
          ),
        },
      ]);
    } catch (e) {
      setRows([{ jenis: "Pertama", bilangan: 0, jumlah: "RM 0.00" }]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isKEWUser) {
      fetchTunggakanData(selectedBahagian);
    } else {
      fetchNotisData();
    }
  }, [selectedBahagian, isKEWUser]);

  const columns = isKEWUser ? [
    { Header: "Bahagian", accessor: "bahagian", align: "left", width: "30%", headerAlign: "center" },
    { Header: "Bil. Inbois", accessor: "bilangan", align: "center", width: "30%", headerAlign: "center" },
    { Header: "Jumlah", accessor: "jumlah", align: "right", width: "40%", headerAlign: "center" },
  ] : [
    { Header: "Jenis Notis", accessor: "jenis", align: "left", width: "50%", headerAlign: "center" },
    { Header: "Bilangan", accessor: "bilangan", align: "center", width: "25%", headerAlign: "center" },
    { Header: "Jumlah", accessor: "jumlah", align: "right", width: "25%", headerAlign: "center" },
  ];

  const loadingRow = isKEWUser 
    ? [{ bahagian: "Loading...", bilangan: "-", jumlah: "-" }]
    : [{ jenis: "Loading...", bilangan: "-", jumlah: "-" }];

  return {
    columns,
    rows: loading ? loadingRow : rows,
    isKEWUser,
    selectedBahagian,
    setSelectedBahagian,
    fetchTunggakanData,
  };
}
